import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// eslint-disable-next-line import-x/no-extraneous-dependencies -- React Query devtools: correctly a devDependency, rendered only under the runtime isDevelopment guard below. NOTE: isDevelopment is a runtime value (not a build-time literal), so this static import currently ships in the prod bundle; a dynamic import() would exclude it (follow-up, out of ONAG-22 scope).
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { isDevelopment } from '../config/env';

/**
 * Configure React Query Client
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
      retry: 0, // Don't retry failed queries (fail fast)
      refetchOnWindowFocus: false,
      networkMode: 'offlineFirst', // Use cache first, network second
    },
    mutations: {
      retry: 0,
    },
  },
});

interface QueryProviderProps {
  children: React.ReactNode;
}

/**
 * React Query Provider Component
 * Wraps the app with QueryClientProvider for data fetching
 */
export const QueryProvider: React.FC<QueryProviderProps> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {isDevelopment && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
};
